export default function classNames(baseClass, classes) {
    const result = [];

    if (typeof baseClass !== 'undefined') {
        result.push(baseClass);
    }

    for (const className in classes) {
        if (classes[className] === true) {
            result.push(className);
        }
    }

    return result.join(' ');
}
